
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Currencies extends Vue {
  @Prop() value!: string;
  @Prop() symbol!: string;
  @Prop() base!: string;
}
